module.exports = __webpack_public_path__ + "static/media/manzo_07_thumb.e2fb852d.png";